import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "hooks/auth/useAuth";
import ProtectedRoute from "./ProtectedRoute";

const SuperUserRoute: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { role } = useAuth();

  return (
    <ProtectedRoute>
      {role === "admin" ||    
      window.location.pathname.includes("/freelo") ? (
        children
      ) : (
        <Navigate to="/not-found" replace />
      )}
    </ProtectedRoute>
  );
};

export default SuperUserRoute;
